import { z } from 'zod/v4'
import { useMesaParameterStore } from '@/src/services/Statsig/useMesaParameterStore'

export const TextSchema = z.object({
  is_enabled: z.boolean(),
  markdown_text: z.string(),
})

export const CardDisclosureSchema = z.object(
  {
    benefits: z.object({ benefits: z.array(TextSchema) }),
    disclosures: z.object({ disclosures: z.array(TextSchema) }),
    partner: z
      .record(
        z.string(),
        z.object({ benefits: z.array(TextSchema), disclosures: z.array(TextSchema) }),
      )
      .optional(),
  },
  { message: 'CardDisclosureSchema must be a valid object' },
)

export type CardDisclosure = z.infer<typeof CardDisclosureSchema>

export function useCardDisclosure() {
  return useMesaParameterStore('card_landing_page_disclosure')
}
